import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

export default reduxApi({
  getThongKeTiepCongDan: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaTiepCongDan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeGQDKN: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaGiaiQuyetDonKhieuNai`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeGQDTC: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaGiaiQuyetDonToCao`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeXuLyDon: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaBaoCaoXuLyDon`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraHanhChinh: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaThanhTraTheoHanhChinh`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraDatDai: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaThanhTraTheoDatDai`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraChuyenNganh: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaThanhTraTheoChuyenNganh`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraXayDungCoBan: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaThanhTraTheoDauTuXayDungCoBan`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeThanhTraTaiChinhNganSach: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaThanhTraTheoTaiChinhNganSach`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKePhatHienThamNhungQuaThanhTra: {
    url: `${API_URL}/thong-ke-bao-cao/BCTN`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getThongKeKetQuaThanhTraLai: {
    url: `${API_URL}/thongKeBaoCaos/tongHopKetQuaThanhTraLai`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getCapCoQuanThongKe: {
    url: `${API_URL}/capCoQuanQuanLys/thongKeBaoCao`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getHinhThucThongKe: {
    url: `${API_URL}/enumerations/hinh-thuc-thong-ke`,
    options: (url, _params, getState) => {
      return {
        method: 'GET'
      };
    }
  },
  getBaoCaoTongHop: {
    url: `${API_URL}/baoCaoTongHops`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoTongHopChiTiet: {
    url: `${API_URL}/baoCaoTongHops/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getKyBaoCao: {
    url: `${API_URL}/thongKeBaoCaoTongHop/loaiKy`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoTongHopDSDonVi: {
    url: `${API_URL}/baoCaoTongHops/:id/donVis`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoTongHopDSBaoCao: {
    url: `${API_URL}/baoCaoTongHops/:id/chiTiets`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDinhKy: {
    url: `${API_URL}/baoCaoDonVis`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDinhKyChiTiet: {
    url: `${API_URL}/baoCaoDonVis/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDinhKyLoaiDon: {
    url: `${API_URL}/baoCaoDonVis/:id/chiTiets`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDonViChiTiet: {
    url: `${API_URL}/baoCaoDonViChiTiets/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getBaoCaoDonViChiTietRow: {
    url: `${API_URL}/baoCaoDonViChiTiets/:id/duLieuDaChots`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  guiBaoCaoDinhKy: {
    url: `${API_URL}/baoCaoDonVis/:id/traKetQua`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  updateBaoCaoDonVi: {
    url: `${API_URL}/baoCaoDonVis/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  getLapBaoCaoDinhKyChiTiet: {
    url: `${API_URL}/baoCaoDonViChiTiets/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDataLapBaoCaoDinhKyChiTiet: {
    url: `${API_URL}/baoCaoDonViChiTietTams/:idBaoCaoDonViChiTiet`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getItemHeThongLapBaoCaoDinhKyChiTiet: {
    url: `${API_URL}/baoCaoDonViChiTietTams/:idBaoCaoDonViChiTiet/themDonVi/:idDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDonViLapBaoCaoDinhKy: {
    url: `${API_URL}/coQuanQuanLys/donViConTrucThuocThuongKes`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  postBaoCao: {
    url: `${API_URL}/baoCaoDonViChiTietTams/multi`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  patchBaoCao: {
    url: `${API_URL}/baoCaoDonViChiTietTams/multi`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteBaoCao: {
    url: `${API_URL}/baoCaoDonViChiTietTams/multi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  getTaiLieuBaoCao: {
    url: `${API_URL}/taiLieuBaoCaos/:id`,
    options : (url, params, getState) => {
      return {
        method: 'GET',
        data: params
      }
    }
  },
  updateTaiLieuBaoCao: {
    url: `${API_URL}/taiLieuBaoCaos/multi`,
    options : (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  postTaiLieuBaoCao: {
    url: `${API_URL}/taiLieuBaoCaos/multi`,
    options : (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      }
    }
  },
  deleteTaiLieuBaoCao: {
    url: `${API_URL}/taiLieuBaoCaos/multi`,
    options : (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      }
    }
  },
  updateTaiLieuDinhKem: {
    url: `${API_URL}/taiLieuBaoCaos/multi`,
    options : (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      }
    }
  },
  postTaiLieuDinhKem: {
    url: `${API_URL}/taiLieuBaoCaos/multi`,
    options : (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      }
    }
  },
  deleteTaiLieuDinhKem: {
    url: `${API_URL}/taiLieuBaoCaos/multi`,
    options : (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      }
    }
  },
  // bao cao tong hop
  getLapBaoCaoTongHopChiTiet: {
    url: `${API_URL}/baoCaoTongHopChiTiets/:id`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDataLapBaoCaoTongHopChiTiet: {
    url: `${API_URL}/baoCaoTongHopChiTiets/:id/chiTiets`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDataLapBaoCaoTongHopChiTietKhac: {
    url: `${API_URL}/baoCaoTongHopChiTietKhacs/:idBaoCaoTongHopChiTiet`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getItemHeThongLapBaoCaoTongHopChiTiet: {
    url: `${API_URL}/baoCaoTongHopChiTietKhacs/:idBaoCaoTongHopChiTiet/themDonVi`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  laySoLieuTongHop: {
    url: `${API_URL}/baoCaoDonViChiTiets/:id/laySoLieu`,
    options: (url, _params, getState) => {
      return {
        method: 'PATCH',
        params: _params
      };
    }
  },
  postBaoCaoTongHop: {
    url: `${API_URL}/baoCaoTongHopChiTietKhacs/multi`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  patchBaoCaoTongHopKhac: {
    url: `${API_URL}/baoCaoTongHopChiTietKhacs/multi`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  patchBaoCaoTongHop: {
    url: `${API_URL}/baoCaoDonViChiTiets/multi`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  patchChotSoLieuDonVi: {
    url: `${API_URL}/baoCaoDonViChiTiets/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  patchChotSoLieuTongHop: {
    url: `${API_URL}/baoCaoTongHopChiTiets/:id`,
    options: (url, params, getState) => {
      return {
        method: 'PATCH',
        data: params
      };
    }
  },
  deleteBaoCaoTongHop: {
    url: `${API_URL}/baoCaoTongHopChiTietKhacs/multi`,
    options: (url, params, getState) => {
      return {
        method: 'DELETE',
        data: params
      };
    }
  },
  getLoaiDonTraCuu: {
    url: `${API_URL}/loaiDonTraCuus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  getDanhSachDonCuThongKe: {
    url: `${API_URL}/donCus`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  }
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/thongKeBaoCao.js